import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetAdminById, GetAllAdminsApi } from "../Apis/Auth/Get_Admins";

export const fetchGetAllAdminsApi = createAsyncThunk(
  "GetAllAdminsApi/fetchGetAllAdminsApi",
  async ({ page = 1, limit = 10, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await GetAllAdminsApi({ page, limit, filters });
      return {
        data: response.data,
        pagination: {
          page: response.page,
          total: response.total,
          totalPages: response.totalPages,
          limit: response.limit || limit,
        }
      };
    } catch (error) {
      return rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch reservations",
      });
    }
  }
);

export const fetchGetAdminById = createAsyncThunk(
  'GetAdminById/fetchGetAdminById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await GetAdminById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  status: null,
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0
  }
};

const AdminSlice = createSlice({
  name: 'Admin',
  initialState,
  reducers: {
    // إضافة action لحذف أدمن من الحالة المحلية
    removeAdminFromState: (state, action) => {
      const adminId = action.payload;
      state.data = state.data.filter(admin => admin.id !== adminId && admin._id !== adminId);
      state.pagination.total = Math.max(0, state.pagination.total - 1);
    }
  },
  extraReducers: (builder) => {
    builder
      // Get Admin By ID cases
      .addCase(fetchGetAdminById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGetAdminById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchGetAdminById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      

      .addCase(fetchGetAllAdminsApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGetAllAdminsApi.fulfilled, (state, action) => {
        state.isLoading = false ;
        state.data = action.payload.data;
        state.pagination = {
          page: action.payload.pagination.page,
          pageSize: action.payload.pagination.limit,
          total: action.payload.pagination.total,
          totalPages: action.payload.pagination.totalPages,
        };
      })
      .addCase(fetchGetAllAdminsApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { removeAdminFromState } = AdminSlice.actions;
export default AdminSlice.reducer;